import { Customer } from "../customer/Customer"
import { Note } from "../note/Note"
import { User } from "../user/User"
import { AuditableResponse } from "../common/AuditableResponse"
import { OrderBuildStepDetails } from "./OrderBuildStepDetails"
import { OrderPartDetails } from "./OrderPartDetails"
import { OrderPaymentDetails } from "./OrderPaymentDetails"
import { OrderServiceDetails } from "./OrderServiceDetails"

export class OrderDetails extends AuditableResponse {
  id: number
  approvedDate: string
  approvedByUser: User
  customerSuppliedParts: string
  onHold: boolean
  total: number
  scheduledDate?: string
  cartridgeId?: number
  customerId: number
  customer: Customer
  buildTypeId: number
  quickbooksInvoiceUrl: string
  notes: Note[]
  orderBuildSteps: OrderBuildStepDetails[]
  orderParts: OrderPartDetails[]
  orderPayments: OrderPaymentDetails[]
  orderServices: OrderServiceDetails[]
  partsDiscountPercentage: number
  partsTotal: number
  servicesDiscountPercentage: number
  servicesTotal: number
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, quickbooksInvoiceUrl: string, scheduledDate: string|undefined, approvedDate: string, approvedByUserJson: any, customerSuppliedParts: string, cartridgeId: number, customerId: number, customer: Customer, buildTypeId: number, total: number, notesJson: any, orderBuildStepsJson: any, orderPartsJson: any, orderPaymentsJson: any, orderServicesJson: any, onHold: boolean, partsDiscountPercentage: number, partsTotal: number, servicesDiscountPercentage: number, servicesTotal: number, createdByUserJson: any, createdDate: string, lastModifiedByUserJson: any, lastModifiedDate: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.quickbooksInvoiceUrl = quickbooksInvoiceUrl
    this.scheduledDate = scheduledDate
    this.approvedDate = approvedDate
    this.approvedByUser = new User(approvedByUserJson)
    this.customerSuppliedParts = customerSuppliedParts
    this.cartridgeId = cartridgeId
    this.customerId = customerId
    this.customer = customer
    this.buildTypeId = buildTypeId
    this.total = total
    this.onHold = onHold
    this.partsDiscountPercentage = partsDiscountPercentage
    this.partsTotal = partsTotal
    this.servicesDiscountPercentage = servicesDiscountPercentage
    this.servicesTotal = servicesTotal
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.orderBuildSteps = orderBuildStepsJson ? orderBuildStepsJson.map((o: any) => new OrderBuildStepDetails(o.id, o.processName, o.processState, o.processStatus, o.completedDate, o.completedByUser)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.orderParts = orderPartsJson ? orderPartsJson.map((o: any) => new OrderPartDetails(o.id, o.displayOrder, o.inventoryItemId, o.name, o.notes, o.price, o.purchaseOrder, o.purchaseOrderAllocationOptions, o.showAllocateFromPurchaseOrder, o.showCreatePurchaseOrderForAllItems, o.showCreatePurchaseOrderForSingleItem, o.showPullFromInventory, o.status, o.totalQuantityOnHand)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.orderPayments = orderPaymentsJson ? orderPaymentsJson.map((o: any) => new OrderPaymentDetails(o.amount, o.receivedDate, o.receivedByUser)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.orderServices = orderServicesJson ? orderServicesJson.map((o: any) => new OrderServiceDetails(o.id, o.buildStepId, o.completed, o.completedByUser, o.completedDate, o.description, o.name, o.notes, o.price, o.serviceFieldValues)) : []
  }
}
